import React from 'react'
import { makeStyles, Card, CardHeader, CardContent, TextField } from '@material-ui/core'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
	fieldWrapper: {
		'& .MuiTextField-root': {
			minWidth: '274px !important',
			marginBottom: 23
		}
	}
}))

const Notes = (props) => {
	const classes = useStyles()

	let { household, setHousehold } = props

	const updateHousehold = (field, value) => {
		if (household) {
			setHousehold({ ...household, [field]: value })
		}
	}

	return (
		<Card className={classes.card}>
			<CardHeader title="Notes" />
			<CardContent>
				<div style={{ marginBottom: 0 }}>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							label="Team Notes"
							variant="filled"
							fullWidth
							value={household.notes}
							onChange={(e) => updateHousehold('notes', e.target.value)}
						/>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							label="Admin Notes"
							variant="filled"
							fullWidth
							value={household.private_admin_notes}
							onChange={(e) => updateHousehold('private_admin_notes', e.target.value)}
						/>
					</div>
				</div>
			</CardContent>
		</Card>
	)
}

export default Notes
